import React, { memo } from 'react';

import { withScreenSize } from '../../../common/utilities/withScreenSize.jsx';
import { MobileDayCardListItemLoadingUI } from './mobileLoadingView/mobileDayCardListItemLoadingUI';
import { LargeDayCardListItemLoadingUI } from './largeLoadingView/largeDayCardListItemLoadingUI';
import { WeekendStartEnd } from '../common/weekendStartEnd';
import { AdUnitLoadingUI } from './common/adUnitLoadingUI';

interface DailyForecastListItemLoadingUIProps {
    isMobile: boolean;
    isWeekendStart: boolean;
    isWeekendEnd: boolean;
    dayCardIndex: number;
}

export const DailyForecastListItemLoadingUI = withScreenSize(memo(({ isMobile, isWeekendEnd, isWeekendStart, dayCardIndex }: DailyForecastListItemLoadingUIProps) => {
    return (
        <>
            {
                isWeekendStart && <WeekendStartEnd key={`weekend-break-start-${dayCardIndex}`} />
            }
            {
                isMobile 
                    ? <MobileDayCardListItemLoadingUI />
                    : <LargeDayCardListItemLoadingUI cardIndex={dayCardIndex} />
            }
            {
                dayCardIndex === 3 && <AdUnitLoadingUI />
            }
            {
                isWeekendEnd && <WeekendStartEnd key={`weekend-break-end-${dayCardIndex}`} />
            }
        </>
    );
}));